import CoursewareItemProvider from '../coursewareItem/CoursewareItemProvider';
import {
  removeChild,
  initChildWithCallback,
  coursewareAncestry,
} from '.';

class APILifecycleService {
  constructor({ id/* , context, coursewareType */ }) {
    this.id = id;
  }

  // The context and childContext where only used to choose the correct entryPoint
  // but now we should be getting the entryPoint directly from the backend.
  async initChild(childId, childContext, respondToInitChildCallback) {
    const entryPoint = await CoursewareItemProvider.getCoursewareEntryPoint(childId);
    initChildWithCallback(this.id, childId, entryPoint, respondToInitChildCallback);
  }

  removeChild(childId) {
    removeChild(this.id, childId);
  }

  async createChild() {
    return Promise.reject(new Error('No child creation on the Learnspace'));
  }

  async deleteChild() {
    return Promise.reject(new Error('No child deletion on the Learnspace'));
  }

  getAncestry() {
    return coursewareAncestry.get(this.id) || [];
  }

  static build(args) {
    return new APILifecycleService(args);
  }
}

export default APILifecycleService;
